import { render, staticRenderFns } from "./ProductCardPriceDiff.vue?vue&type=template&id=44fa0ec3&scoped=true&"
import script from "./ProductCardPriceDiff.vue?vue&type=script&lang=js&"
export * from "./ProductCardPriceDiff.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardPriceDiff.vue?vue&type=style&index=0&id=44fa0ec3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fa0ec3",
  null
  
)

export default component.exports